<template>
    <v-content>
      <v-container fluid style="position: relative">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card>
              <v-container fluid>
                <v-card-title>    
                  <v-btn icon href="/resources">
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>  
                  {{ 'Add Resources' | translate }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-form id="form" ref="form">
                    <v-row>
                      <v-col cols="12" sm="9" md="9">
                        <v-row v-if="errors">
                          <v-col cols="12" sm="12" md="12">
                            <v-alert
                              dense
                              v-for="(v, k) in errors"
                              :key="k"
                              outlined
                              type="error"
                            >{{ k }} {{ v }}</v-alert>
                          </v-col>
                        </v-row>
  
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              outlined
                              :label="'Resource Name' | translate"
                              v-model="resource_name"
                              name="resource_name"
                              autocomplete="off"
                              :rules="templatenameRules"
                              required
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>                            
                            </v-text-field>
                          </v-col>
                        </v-row>
  
                          <v-row>
                              <v-col cols="12" sm="12">
                                  <v-autocomplete
                                      v-model="resourceType"
                                      :items="TypeOfresources"
                                      item-value="value"
                                      item-text="text"
                                      :label="'Resource Type' | translate"
                                      outlined
                                      chips
                                      small-chips
                                      required
                                      :rules="resourceTypeRules"
                                      :no-data-text="$t('No data available')"
                                  >
                                  <template #message="{ message }">
                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                  </template>
                                  </v-autocomplete>
                              </v-col>
                          </v-row>

                            <div v-if="resourceType">
                                <v-row v-if="resourceType=='image'">
                                    <v-col>
                                        <v-file-input
                                            id="resource_image"
                                            name="filename"
                                            v-model="image_link"
                                            outlined
                                            chips
                                            required
                                            :rules="imageRules"
                                            :label="'Image Upload' | translate"
                                            @change="onFileSelected"
                                        >
                                            <template #message="{ message }">
                                            {{
                                                curLanguage.lang_code == "en"
                                                ? message
                                                : $t(message)
                                            }}
                                            </template>
                                        </v-file-input>
                                    </v-col>
                                </v-row>
        
                                <v-row v-else>
                                    <v-col>
                                        <v-text-field
                                            outlined
                                            :label="'Video Resource Link' | translate"
                                            v-model="video_link"
                                            name="video"
                                            autocomplete="off"
                                            :rules="videoLinkRules"
                                            required
                                            >
                                            <template #message="{ message }">
                                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                            </template>                            
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
  
                      </v-col>
                      <v-col cols="12" sm="4" md="4"></v-col>
                    </v-row>
                  </v-form>
                  <v-btn
                    dark
                    fab
                    fixed
                    bottom
                    right
                    large
                    color="pink"
                    class="mx-2"
                    @click="submit"
                  >
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                </v-card-text>
  
                            
              </v-container>
            </v-card>
         </v-col>
        </v-row>
      </v-container>
    </v-content>
</template>  
  
  <script>
  import {
    ADD_ADDITIONAL_PAGE_RESOURCE,
    FETCH_COMPANY_SETTINGS,
    RESET_STATE
  } from "@/store/actions.type";
  import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
  import store from "@/store"
  import { mapState } from "vuex"
  import { mapGetters } from "vuex"
  export default {
    name: "addcustomemailtemplate",
    async beforeRouteUpdate(to, from, next) {
      await store.dispatch(RESET_STATE)
      return next();
    },
    async beforeRouteEnter(to, from, next) {
      Promise.all([
          await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile')
      ]).then(() => {
          store.commit(SET_LOADING, false)
        }) 
      store.commit(SET_ROUTER_ENTER, false)
  
      return next();
    },
    async beforeRouteLeave(to, from, next) {
      await store.dispatch(RESET_STATE)
      next();
    },
    computed: {
      ...mapGetters([ 'currentUser', 'curLanguage']),
      ...mapState({
        errors: state => state.additionalpage.pageerrors,
      }),
      templatenameRules(){  return [v => !!v || "Template name is required"]},
      resourceTypeRules(){  return [v => !!v || "resource Type is required"]},
      imageRules(){  return [v => !!v || "Image is required"]},
      videoLinkRules(){  return [v => !!v || "Video is required"]},
      TypeOfresources(){
        return [
            {value: 'image', text:this.$t('Image')},
            {value: 'video', text:this.$t('Video')},
        ]
      },
    },
    async mounted () {
      if(this.currentUser.roles.includes(1) == false){
        this.$router.push('/dashboard');
      }
    },
    data: function() {
      return {
        resource_name: null,
        resourceType: false,
        image_link:null,
        video_link:null,
        url:null,
      }
    },
    methods : {
        onFileSelected() {
            this.image_link = document.getElementById("resource_image").files[0];
            this.url = URL.createObjectURL(this.image_link);
        },
        submit: function() {
            if (this.$refs.form.validate()) {
                var formData = new FormData(document.getElementById("form"));
                
                formData.set("name", this.resource_name);
                formData.set("resource_type", this.resourceType);
                
                if(this.resourceType=='image'){
                    if (this.image_link != null) {
                        formData.set("file", this.image_link);
                    }
                }
                else if(this.resourceType=='video'){
                    if (this.video_link != null) {
                        formData.set("file", this.video_link);
                    }
                }
             
                this.$store.dispatch(ADD_ADDITIONAL_PAGE_RESOURCE, formData).then((resp) => {
                    if (
                        resp != undefined &&
                        resp.hasOwnProperty("success") &&
                        resp.success
                    ) {
                        store.commit(SET_LOADING, false);
                        store.commit(SET_SNACKBAR, {
                        status: true,
                        message: "Resource created successfully",
                        });
                        this.$router.push({ name: "resources" });
                    } else {
                        store.commit(SET_LOADING, false);
                    }
                });

            }
        },
    },
  };
  </script>
